module.exports = __webpack_public_path__ + "static/media/SPM.0ec3e076.jpg";